/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupNotificationSetting } from '../../models/facility-group-notification-setting';
import { NotificationTitle } from '../../models/notification-title';
import { NotificationType } from '../../models/notification-type';

export interface GetSetting_2$Params {
  facilityGroupId: number;
  title: NotificationTitle;
  type: NotificationType;
}

export function getSetting_2(http: HttpClient, rootUrl: string, params: GetSetting_2$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, getSetting_2.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.path('title', params.title, {});
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityGroupNotificationSetting>;
    })
  );
}

getSetting_2.PATH = '/api/facilityGroup/notification/setting/title/{title}/type/{type}/facilityGroupId/{facilityGroupId}';
